import React from "react";
import "./progress.css";
import { useSelector } from "react-redux";

const Stepper = ({ SubsData }) => {
  // Get User Data from Redux
  const userStore = useSelector((state) => state.userReducer);
  const user = userStore?.users?.user;

  // Assuming SubsData is available in your component (via another selector or prop)
  const isSubscribed = SubsData?.isSubscription;

  // Godzilla qualification logic
  const isGodzillaActive = user?.isWeexQualify || user?.isMexcQualify;

  // Determine currentStep number
  let currentStep = 3; // Default starting point since they are logged in

  if (isSubscribed) {
    currentStep = 6; // They passed Sub, Payment, and now have Dashboard Access
  }

  if (isSubscribed && isGodzillaActive) {
    currentStep = 7; // Final step
  }

  const steps = [
    "Create Account",
    "Login",
    "Subscription",
    "Complete Payment",
    "Dashboard Access",
    "Unlock Godzilla",
  ];

  return (
    <div className="stepper-container">
      <div className="stepper">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isActive = stepNumber === currentStep;

          return (
            <React.Fragment key={step}>
              {/* Step Circle and Label */}
              <div
                className={`step ${isCompleted ? "completed active" : ""} ${isActive ? "pulsing active" : ""}`}
              >
                <div className="step-icon">
                  {isCompleted && <span className="checkmark">✓</span>}
                  {isActive && (
                    <span className="step-number">{stepNumber}</span>
                  )}
                </div>
                <div className="step-label">{step}</div>
              </div>

              {/* Connector Line (don't show after the last step) */}
              {index < steps.length - 1 && (
                <div
                  className={`step-line ${stepNumber < currentStep ? "active" : ""} ${isActive ? "pulsing" : ""}`}
                ></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
